// Foundation Stage Student Book — Little Hearts (Ages 4–5)
// Phase 2 launch: 4 starter chapters at low-reading age. Designed for read-aloud
// + gentle activity. Full 12-chapter expansion to follow in a future release.

export const META = {
  series: "Ambedkarite Buddhist Educational Series — UK Edition",
  title: "Little Hearts · Foundation Stage",
  subtitle: "Ages 4–5 · Big-feeling stories for the youngest learners",
  edition: "Phase 2 · Sample Edition · 2026",
  status: "4 chapters published · 8 more in development",
};

// Each chapter is short and read-aloud friendly.
export const CHAPTERS = [
  {
    n: 1,
    title: "Big Hellos",
    bigIdea: "Everyone in our circle is welcome.",
    storyTitle: "Mira and the Morning Hello",
    story: [
      "Mira walked into her new classroom on a sunny Monday. There were so many faces!",
      "She felt small. Her tummy was a tiny bit fluttery.",
      "Then a boy named Rafi smiled and said, '<strong>Hello, friend.</strong>'",
      "Mira said hello back. Her tummy felt better.",
      "By snack-time, Mira had said hello to <strong>seven</strong> new friends.",
      "What a brave Monday for Mira!",
    ],
    activityTitle: "Our Hello Circle",
    activity: [
      "<strong>Sit</strong> in a circle.",
      "<strong>Smile</strong> at the person next to you.",
      "Say <strong>'Hello, friend'</strong> in a soft, kind voice.",
      "Pass it round the whole circle.",
    ],
    talkPrompts: [
      "How does it feel when somebody says hello to you?",
      "Can a smile be a hello too?",
      "Who in your home gives the BEST hello?",
    ],
  },
  {
    n: 2,
    title: "Kind Hands",
    bigIdea: "My hands can help other hands.",
    storyTitle: "The Crayon That Rolled Away",
    story: [
      "Anya was drawing a big yellow sun. Her best red crayon rolled <strong>off the table</strong>.",
      "It rolled and rolled and rolled — all the way to Sam.",
      "Sam picked it up. He looked at the crayon. He could keep it.",
      "But Sam smiled. He walked it back to Anya.",
      "Anya said, '<strong>Thank you, Sam.</strong>' Sam felt warm inside, like sunshine.",
    ],
    activityTitle: "Helping Hands Hunt",
    activity: [
      "Find <strong>three</strong> things in the classroom your hands can help with.",
      "Examples: tidy a book, pass a toy, wipe a table.",
      "When you've helped, give yourself a big <strong>'I helped!'</strong> wave.",
    ],
    talkPrompts: [
      "What do your hands do that is kind?",
      "Has a friend ever returned something you lost?",
      "Can helping hands feel happy?",
    ],
  },
  {
    n: 3,
    title: "The Slow Breath",
    bigIdea: "When my heart is loud, my breath can help it whisper.",
    storyTitle: "Beni and the Big Feeling",
    story: [
      "Beni was building a tower. The tower was almost as <strong>tall as him</strong>.",
      "Crash! It fell down.",
      "A BIG feeling came up. Beni's tummy was hot. His eyes were wet.",
      "His teacher knelt down. 'Let's <strong>breathe</strong>,' she whispered.",
      "Beni breathed in slowly. Then out, even slower.",
      "The big feeling got <strong>smaller</strong>. His hands felt steady. He started building again.",
    ],
    activityTitle: "Belly-Breath",
    activity: [
      "Lie on your back. Place a soft toy on your tummy.",
      "Breathe IN — the toy goes UP.",
      "Breathe OUT — the toy goes DOWN.",
      "Do this <strong>five</strong> times. Notice your tummy.",
    ],
    talkPrompts: [
      "What does a 'big feeling' feel like?",
      "Where in your body do feelings live?",
      "Who can you tell when your feelings are big?",
    ],
  },
  {
    n: 4,
    title: "Everyone Eats",
    bigIdea: "Sharing food turns 'mine' into 'ours'.",
    storyTitle: "The Picnic on the Mat",
    story: [
      "Tariq's class had a picnic on the carpet.",
      "Everyone brought one snack to share.",
      "Tariq brought a banana. Lily brought a biscuit. Jake brought grapes.",
      "When all the snacks were on the mat, there was a feast!",
      "Tariq tasted a green grape for the very <strong>first time</strong>.",
      "He smiled and said, '<strong>Sharing makes more.</strong>'",
    ],
    activityTitle: "Pretend Picnic",
    activity: [
      "Sit in a circle. Each child names one favourite food.",
      "Pretend to put your food on a big shared mat.",
      "Take it in turns to <strong>'taste'</strong> something new.",
      "Say <strong>'Thank you for sharing'</strong> after each taste.",
    ],
    talkPrompts: [
      "What food does your family share at home?",
      "Why does food taste better with friends?",
      "Can you share something that ISN'T food?",
    ],
  },
];
